export default __webpack_public_path__ + "static/media/16.e881d335.png";